module.exports = __webpack_public_path__ + "img/14.e25c7eb3.svg";